import React from 'react'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  children: React.ReactNode
  footer?: React.ReactNode
  icon?: React.ReactNode
  iconBg?: string
  hideHeader?: boolean
  disableClose?: boolean
}

export type { ModalProps }
export const Modal: React.FC<ModalProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  children,
  footer,
  icon,
  iconBg,
  hideHeader = false,
  disableClose = false
}) => {
  if (!isOpen) return null

  return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="flex items-center justify-center w-full max-w-md">
      <div className="bg-white rounded-xl shadow-lg w-full flex flex-col m-4 md:max-h-[90vh] max-h-[80vh] overflow-y-auto">
        {/* Header */}
        {!hideHeader && (
          <div className="flex justify-between items-center p-4 border-b">
            <div className="flex items-center gap-2">
              {icon && (
                <div className={`${iconBg || 'bg-gray-100'} p-2 rounded-lg`}>
                  {icon}
                </div>
              )}
              <h2 className="text-lg font-medium">{title}</h2>
            </div>
            {!disableClose && (
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            )}
          </div>
        )}

        {/* Content - Scrollable */}
        <div className="flex-1 overflow-y-auto p-4">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="border-t p-4">
            {footer}
          </div>
        )}
      </div>
    </div>
    </div>
  )
}